import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import DepartmentDropdown from './DepartmentDropdown';
import PeriodDropdown from './PeriodDropdown';
import YearDropdown from './YearDropdown';

interface ViewCheckbookActionsProps {}

const ViewCheckbookActions: FC<ViewCheckbookActionsProps> = () => {
  const { t } = useTranslation();
  const { selectedView, setSelectedView, isPeriodView, confirmBeforeProceeding, setIsEditMode } =
    useViewCheckbook();

  const handleSelect = useCallback(
    (e: TabStripSelectEventArguments) => {
      const { selected } = e;
      confirmBeforeProceeding(() => {
        setSelectedView(selected);
        setIsEditMode(false);
      });
    },
    [confirmBeforeProceeding, setIsEditMode, setSelectedView]
  );

  return (
    <div className="flex items-center gap-4 mt-4 mb-2">
      <TabStrip selected={selectedView} onSelect={handleSelect} className="min-w-[190px]">
        <TabStripTab contentClassName="!hidden" title={t('Period View')} />
        <TabStripTab contentClassName="!hidden" title={t('Year View')} />
      </TabStrip>
      <DepartmentDropdown />
      {isPeriodView ? <PeriodDropdown /> : <YearDropdown />}
    </div>
  );
};

export default ViewCheckbookActions;
